import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const messagesModules = {
  pt: {
    ...require('@/translations/ptbr.json')
  },
  en: {
    ...require('@/translations/enus.json')
  }
}
export default new VueI18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'pt',
  messages: messagesModules
})



// WEBPACK FOOTER //
// ./src/i18n.js